// import React, { Component } from 'react';
// import './../../css/table.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEdit, faTrash, faInfo } from '@fortawesome/free-solid-svg-icons';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import withReactContent from 'sweetalert2-react-content';
// import { Link } from 'react-router-dom';
// import Spinner from 'react-bootstrap/Spinner';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import moment from 'jalali-moment';

// const MySwal = withReactContent(Swal);

// export default class OpportunityTable extends Component {
//   constructor() {
//     super();
//     this.state = {
//       posts: [],
//       search:''
//     };
//   }
//   componentDidMount() {
//     this.getPost();
//     this.getUnreadResumes();
//   }

//   getUnreadResumes() {
//     axios
//       .get('https://arianaapp.arianaapply.com/panel/show-new-resumejobopportunity')
//       .then((res) => {
//         console.log('Unread', res);
//       })
//       .catch((err) => {
//         console.log('err Unread', err);
//       });
//   }
//   deleteHandler(id) {
//     axios
//       .get(`https://arianaapp.arianaapply.com/panel/job-opportunity-delete/${id}`)
//       .then((res) => {
//         console.log(res);

//         Swal.fire({
//           title: 'با موفقیت حذف شد',
//           icon: 'success',
//         }).then((res) => {
//           window.location.reload();
//         });
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }

//   render() {
//     return (
//       <div className='index'>
//         {this.state.posts.length > 0 ? (
//           <div className='table'>
//             <div style={{width:'100%', display:'flex', justifyContent:'center', margin:'1rem 0'}}>
//               <input
//                 className='search-input'
//                 type='search'
//                 name='search'
//                 value={this.state.search}
//                 placeholder='جستجو کنید....'
//                 onChange={(e) => this.setState({search: e.target.value})}
//               />
//             </div>
//             <table>
//               <thead>
//                 <tr>
//                   <td>#</td>
//                   <td>عنوان</td>
//                   <td>شهر</td>
//                   <td>کشور</td>
//                   <td>دسته</td>
//                   <td>شرکت</td>
//                   <td>تاریخ</td>
//                   <td>عملیات</td>
//                   <td>رزومه </td>
//                 </tr>
//               </thead>
//               <tbody>
//                 {this.state.posts.filter((p => p.title.toLowerCase().includes(this.state.search))).reverse().map((item, i) => (
//                   <tr key={item._id}>
//                     <td>{i}</td>
//                     <td>{item.title}</td>
//                     <td>{item.city}</td>
//                     <td>{item.country}</td>
//                     <td>{item.type}</td>
//                     <td>{item.company}</td>
//                     <td>
//                       {(() => {
//     try {
//       return item.created_at
//         ? moment(item.created_at).locale('fa').format('YYYY/MM/DD')
//         : '-';
//     } catch (e) {
//       return '-';
//     }
//   })()}
//                       </td>
//                     <td>
//                       <div className='d-flex'>
//                         <Link to={`/opportunity-edit/${item._id}`}>
//                           <button className='success'>
//                             <FontAwesomeIcon icon={faEdit} />
//                           </button>
//                         </Link>
//                         <button
//                           className='danger'
//                           onClick={() => this.deleteHandler(item._id)}>
//                           <FontAwesomeIcon icon={faTrash} />
//                         </button>
//                       </div>
//                     </td>
//                     <td>
//                       <Link to={`/job-resume/${item._id}`}>
//                         <button className='info'>
//                           <FontAwesomeIcon icon={faInfo} />
//                         </button>
//                       </Link>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <Spinner animation='border' variant='primary' />
//         )}
//       </div>
//     );
//   }

//   getPost() {
//     axios
//       .get('https://arianaapp.arianaapply.com/panel/job-opportunity-list')
//       .then((response) => {
//         this.setState({ posts: response.data.data });
//         console.log(response);
//       })
//       .catch((err) => {
//         console.log(err.response);
//         MySwal.fire({
//           title: 'دوباره امتحان کنید',
//           icon: 'error',
//         });
//       });
//   }
// }



import React, { Component } from 'react';
import './../../css/table.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faInfo } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Link } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'jalali-moment';

const MySwal = withReactContent(Swal);

export default class OpportunityTable extends Component {
  constructor() {
    super();
    this.state = {
      posts: [],
      search: '',
      selectedIds: [],
      lastSelectedIndex: -1
    };
  }

  componentDidMount() {
    this.getPost();
    this.getUnreadResumes();
  }

  getUnreadResumes() {
    axios
      .get('https://arianaapp.arianaapply.com/panel/show-new-resumejobopportunity')
      .then((res) => {
        console.log('Unread', res);
      })
      .catch((err) => {
        console.log('err Unread', err);
      });
  }

  getPost() {
    axios
      .get('https://arianaapp.arianaapply.com/panel/job-opportunity-list')
      .then((response) => {
        this.setState({ posts: response.data.data || [] });
      })
      .catch((err) => {
        console.log(err.response);
        MySwal.fire({
          title: 'دوباره امتحان کنید',
          icon: 'error',
        });
      });
  }

  // انتخاب / لغو انتخاب یک مورد
  toggleSelect = (id) => {
    this.setState((prev) => {
      const selectedIds = prev.selectedIds.includes(id)
        ? prev.selectedIds.filter((item) => item !== id)
        : [...prev.selectedIds, id];
      return { selectedIds };
    });
  };

  // انتخاب همه
  selectAll = () => {
    const allIds = this.state.posts.map((item) => item._id);
    this.setState({ selectedIds: allIds });
  };

  // لغو انتخاب همه
  deselectAll = () => {
    this.setState({ selectedIds: [], lastSelectedIndex: -1 });
  };

  // انتخاب ۵ مورد بعدی
  selectNext5 = () => {
    const { posts, lastSelectedIndex, selectedIds } = this.state;
    const start = lastSelectedIndex + 1;
    const end = Math.min(start + 5, posts.length);

    if (start >= posts.length) {
      MySwal.fire({
        title: 'مورد دیگری برای انتخاب وجود ندارد',
        icon: 'info',
      });
      return;
    }

    const newIds = posts.slice(start, end).map((item) => item._id);
    const uniqueIds = [...new Set([...selectedIds, ...newIds])];

    this.setState({
      selectedIds: uniqueIds,
      lastSelectedIndex: end - 1
    });
  };

  // حذف گروهی (بهینه)
  deleteSelected = () => {
    const { selectedIds } = this.state;

    if (selectedIds.length === 0) {
      MySwal.fire({
        title: 'هیچ موردی انتخاب نشده است',
        icon: 'warning',
      });
      return;
    }

    Swal.fire({
      title: 'آیا مطمئن هستید؟',
      text: `${selectedIds.length} فرصت شغلی و تمام داده‌های وابسته حذف خواهند شد`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'بله، حذف شوند',
      cancelButtonText: 'انصراف'
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post('https://arianaapp.arianaapply.com/panel/job-opportunity-delete-many', {
            ids: selectedIds
          })
          .then((res) => {
            Swal.fire({
              title: 'با موفقیت حذف شدند',
              text: res.data.message || '',
              icon: 'success',
            }).then(() => {
              this.setState({ selectedIds: [], lastSelectedIndex: -1 });
              this.getPost();
            });
          })
          .catch((err) => {
            console.log(err);
            Swal.fire({
              title: 'خطا در حذف',
              text: err.response?.data?.message || 'مشکلی پیش آمد',
              icon: 'error',
            });
          });
      }
    });
  };

  // حذف تکی
  deleteHandler(id) {
    Swal.fire({
      title: 'آیا مطمئن هستید؟',
      text: 'این فرصت شغلی حذف خواهد شد',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'بله، حذف شود',
      cancelButtonText: 'انصراف'
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`https://arianaapp.arianaapply.com/panel/job-opportunity-delete/${id}`)
          .then((res) => {
            Swal.fire({
              title: 'با موفقیت حذف شد',
              icon: 'success',
            }).then(() => {
              this.getPost();
            });
          })
          .catch((err) => {
            console.log(err);
            Swal.fire({
              title: 'خطا در حذف',
              icon: 'error',
            });
          });
      }
    });
  }

  render() {
    const { posts, search, selectedIds } = this.state;

    const filteredPosts = posts
      .filter((p) => (p.title || '').toLowerCase().includes((search || '').toLowerCase()))
      .reverse();

    return (
      <div className='index'>
        {posts.length > 0 ? (
          <div className='table'>
            {/* نوار ابزار */}
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '10px',
                margin: '1rem 0',
                padding: '0 10px'
              }}
            >
              <input
                className='search-input'
                type='search'
                name='search'
                value={search}
                placeholder='جستجو کنید....'
                onChange={(e) => this.setState({ search: e.target.value })}
              />

              <button
                className='info'
                onClick={this.selectNext5}
                style={{ width: 'auto', padding: '0 12px', height: '35px' }}
              >
                انتخاب ۵ مورد بعدی
              </button>

              <button
                className='success'
                onClick={this.selectAll}
                style={{ width: 'auto', padding: '0 12px', height: '35px' }}
              >
                انتخاب همه
              </button>

              <button
                className='danger'
                onClick={this.deselectAll}
                style={{ width: 'auto', padding: '0 12px', height: '35px' }}
              >
                لغو انتخاب
              </button>

              <button
                className='danger'
                onClick={this.deleteSelected}
                disabled={selectedIds.length === 0}
                style={{
                  width: 'auto',
                  padding: '0 12px',
                  height: '35px',
                  background: selectedIds.length ? '#dc3545' : '#aaa',
                  cursor: selectedIds.length ? 'pointer' : 'not-allowed'
                }}
              >
                حذف انتخاب‌شده‌ها ({selectedIds.length})
              </button>
            </div>

            <table>
              <thead>
                <tr>
                  <td style={{ width: '50px' }}>انتخاب</td>
                  <td>#</td>
                  <td>عنوان</td>
                  <td>شهر</td>
                  <td>کشور</td>
                  <td>دسته</td>
                  <td>شرکت</td>
                  <td>تاریخ</td>
                  <td>عملیات</td>
                  <td>رزومه</td>
                </tr>
              </thead>
              <tbody>
                {filteredPosts.map((item, i) => (
                  <tr key={item._id}>
                    <td>
                      <input
                        type='checkbox'
                        checked={selectedIds.includes(item._id)}
                        onChange={() => this.toggleSelect(item._id)}
                        style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                      />
                    </td>
                    <td>{i + 1}</td>
                    <td>{item.title}</td>
                    <td>{item.city}</td>
                    <td>{item.country}</td>
                    <td>{item.type}</td>
                    <td>{item.company}</td>
                    <td>
                      {(() => {
                        try {
                          return item.created_at
                            ? moment(item.created_at).locale('fa').format('YYYY/MM/DD')
                            : '-';
                        } catch (e) {
                          return '-';
                        }
                      })()}
                    </td>
                    <td>
                      <div className='d-flex'>
                        <Link to={`/opportunity-edit/${item._id}`}>
                          <button className='success'>
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </Link>
                        <button
                          className='danger'
                          onClick={() => this.deleteHandler(item._id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                    </td>
                    <td>
                      <Link to={`/job-resume/${item._id}`}>
                        <button className='info'>
                          <FontAwesomeIcon icon={faInfo} />
                        </button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <Spinner animation='border' variant='primary' />
        )}
      </div>
    );
  }
}